import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../servicio/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  verDashboard = true;
  constructor(public authenticationService: AuthenticationService) { }

  ngOnInit(): void {
  }
}
